import dateLocales from '@amzn/meridian/_utils/date-locales';
import { DatePickerLocale } from '@amzn/meridian/date-picker/date-picker';

const DATE_PICKER_LOCALES = Object.keys(dateLocales) as DatePickerLocale[];

const ISO_FORMAT_DATE_PICKER_LOCALE: DatePickerLocale = 'en-CA';

export const datePickerLocale = (language: string): DatePickerLocale =>
    DATE_PICKER_LOCALES.find((locale) => locale === language) ?? ISO_FORMAT_DATE_PICKER_LOCALE;
